import React from "react"
import a from "../image/a.png"
import b from "../image/b.png"
import c from "../image/c.png"
import d from "../image/d.png"
import e from "../image/e.png"
import ff from "../image/ff.png"
import i from "../image/i.png"
import j from "../image/j.png"
import k from "../image/k.png"
import covid from "../image/covid.png"
import goog from "../image/goog.png"


export default function AboutMe() {
  return (
    <section id="works" class="bg-white mt-16 mb-16">
      <h1 class="w-full my-2 text-4xl font-bold leading-tight text-center text-gray-800">
        作れるようになります！
      </h1>

      <div class="w-full">
        <div class="h-1 mx-auto gradient w-64 opacity-25  rounded-t"></div>
      </div>
      <p class=" mx-10 my-10 text-lg  text-center text-gray-800">
        取り上げる題材の一例です。実際のサービスに応用の効く技術を多く取り入れた作品を扱います。
      </p>
      <div class="container mx-auto px-6 ">
        <div class="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-6">
          <a href="https://kriesi.at/themes/enfold-overview/">
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${d})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700 uppercase">最速のWeb開発</h3>
                <span class="text-gray-500 mt-2">
                  Wordpress -
                  最小の労力でリンク先のようなWebサイトを簡単に構築します。まずはここから！
                </span>
              </div>
            </div>
          </a>
          <a href="/">
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${b})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700 uppercase">このWebサイト</h3>
                <span class="text-gray-500 mt-2">
                  React + Gatsby.js + AWS -
                  最速の読み込み時間を保証するGatsby.jsで静的サイトの構築方法を学びます。
                </span>
              </div>
            </div>
          </a>

          <a href="https://googl-60067.web.app/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${goog})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700">Google風検索エンジン</h3>
                <span class="text-gray-500 mt-2">
                  React + Firebase -
                  GoogleAPIを利用してGoogle風検索エンジンを構築します。
                </span>
              </div>
            </div>
          </a>

          <a href="https://ig-reels-9c9a7.web.app/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${i})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700">Instagram風Reels</h3>
                <span class="text-gray-500 mt-2">
                  React + Firebase -
                  Instagramの動画投稿機能であるReelsの構築方法について学びます。
                </span>
              </div>
            </div>
          </a>


          <a href="https://whatapp-18d1b.web.app/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${ff})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700">WhatsApp風チャットアプリ</h3>
                <span class="text-gray-500 mt-2">
                  React + Firebase -
                  Googleログイン、ルーム作成機能を備えたチャットアプリの構築を学びます。
                </span>
              </div>
            </div>
          </a>




          <a href="https://csb-u8h3u.netlify.app/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${a})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700">Messenger風チャットアプリ</h3>
                <span class="text-gray-500 mt-2">
                  React + Firebase -
                  おなじみのチャットアプリがどのような技術で構築されているのかを学びます。
                </span>
              </div>
            </div>
          </a>

          <a href="https://csb-w9ui7.netlify.app/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${c})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700 uppercase">
                  NETFLIX風デザインの映画サイト
                </h3>
                <span class="text-gray-500 mt-2">
                  React + Firebase -
                  リアルタムな映画情報をAPIで取得、NETFLIX風デザインに組み込む方法を学びます。
                </span>
              </div>
            </div>
          </a>

          <a href="https://covid-19-f9260.web.app/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${covid})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700">Covid19</h3>
                <span class="text-gray-500 mt-2">
                  React + Firebase -
                  新型コロナウィルス感染者状況を題材にデータの視覚化を学びます
                </span>
              </div>
            </div>
          </a>

          <a href="https://worldstats-25bd3.web.app/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${k})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700">WorldStats</h3>
                <span class="text-gray-500 mt-2">
                  React + Firebase -
                  世界銀行の統計データを元にデータの視覚化にチャレンジします。※PC閲覧推奨
                </span>
              </div>
            </div>
          </a>

          <a href="https://docs.google.com/spreadsheets/d/1TvpphuWrzqvYMj8MT5BVSkgvJleotqc5jwKjrDvscVw/edit?usp=sharing">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${e})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700 uppercase">株価分析</h3>
                <span class="text-gray-500 mt-2">
                  Python -
                  私が実際に使用している株価分析プログラムを題材にデータ分析を学びます。
                </span>
              </div>
            </div>
          </a>

          <a href="https://guarded-earth-74633.herokuapp.com/">
            {" "}
            <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
              <div
                class="flex items-end justify-end h-56 w-full bg-cover"
                style={{
                  backgroundImage: `url(${j})`,
                }}
              ></div>
              <div class="px-5 py-3">
                <h3 class="text-gray-700">ビデオチャット</h3>
                <span class="text-gray-500 mt-2">
                  Node.js + Heroku -
                  映像と音声を共有できるビデオチャットを構築します。※現在PCでのみ接続可
                </span>
              </div>
            </div>
          </a>



          <div class="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden">
            <p class="flex items-center justify-center h-56  text-gray-900 text-2xl mt-6 md:mt-12">
              Coming Soon
            </p>
            <div class="px-5 py-3">
              <h3 class="text-gray-700 uppercase"></h3>
              <span class="text-gray-500 mt-2"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
